import { render, staticRenderFns } from "./CartaoListaDeSolicitacoes.vue?vue&type=template&id=128ea69f&scoped=true"
import script from "./CartaoListaDeSolicitacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoListaDeSolicitacoes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoListaDeSolicitacoes.vue?vue&type=style&index=0&id=128ea69f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ea69f",
  null
  
)

export default component.exports